import React, { useEffect, useState } from 'react';
import { Box, Card, CardBody, Image, Text, Flex, SimpleGrid, Spinner, Center, Select, Button, InputGroup, InputLeftElement, Input, Menu, MenuButton, MenuList, IconButton, MenuItem, Badge, Stack, Switch, AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, AlertDialogBody, AlertDialogFooter, useToast, MenuDivider, useColorModeValue, Checkbox, Modal, ModalOverlay, ModalHeader, ModalCloseButton, ModalBody, Textarea, ModalFooter, ModalContent, useDisclosure } from '@chakra-ui/react';
import axiosClient from '../../../axios-client';
import MyPagination from '../../../components/MyPagination';
import { AiOutlineUserAdd } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PiPlusBold } from 'react-icons/pi';
import { SearchIcon } from '@chakra-ui/icons';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { useStateContext } from '../../../context/ContextProvider';
import MySelect from 'react-select';
import RatingsModal from '../Ratings/RatingsModal';

const GestSeries = () => {
    const [series, setSeries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [paginationData, setPaginationData] = useState()
    const [selectedEtat, setSelectedEtat] = useState(null);
    const [selectedFeature, setSelectedFeature] = useState(null);

    const [loadingData, setLoadingData] = useState(true)
    const [searchTerm, setSearchTerm] = useState('');
    const [checkLengthData, setCheckLengthData] = useState(false)
    const navigate = useNavigate()
    const [currentPage, setCurrentPage] = useState(0);

    const [deleteId, setDeleteId] = useState(null);
    const [contentId, setContentId] = useState(null);

    const toast = useToast()
    const { user } = useStateContext();
    const { t } = useTranslation()

    const colorbg = useColorModeValue('white', '#2d3748')
    const txtcolor = useColorModeValue('black', 'white')
    const colorbghover = useColorModeValue('#e2e8f0', '#171923')
    const cancelRef = React.useRef()

    const [isHighlightModalOpen, setIsHighlightModalOpen] = useState(false);
    const [isNewContentModalOpen, setIsNewContentModalOpen] = useState(false);

    const [highlightText, setHighlightText] = useState('');
    const [selectedContentId, setSelectedContentId] = useState(null);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [highlightTag, setHighlightTag] = useState("");


    const [isAlertOpen, setIsAlertOpen] = useState(false);

    const onOpenAlert = (id) => {
        setIsAlertOpen(true);
        setDeleteId(id)
    };

    const onCloseAlert = () => {
        setIsAlertOpen(false);
    };
    const handleOpenRatingsModal = (id) => {
        setContentId(id);
        onOpen();
    };
    const openHighlightModal = (contentId) => {
        setSelectedContentId(contentId);
        setHighlightText('');
        setIsHighlightModalOpen(true);
    };

    const openNewContentModal = (contentId) => {
        setSelectedContentId(contentId);
        setIsNewContentModalOpen(true);
    };
    ////////////////////////////////the size of the table//////////////////////////////
    const PAGE_SIZE = 10;
    const [pageSize, setPageSize] = useState(PAGE_SIZE);
    const handlePageSizeChange = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setPageSize(newSize);
        setCurrentPage(0);
    };
    //////////////////////////////////////////////////////////////////////////////////
    const [selectedSubcategory, setSelectedSubcategory] = useState(null);
    const [subcategoryOptions, setSubcategoryOptions] = useState([]);

    const [categoryOptions, setCategoryOptions] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    // Fetch Subcategories Grouped by Categories
    useEffect(() => {
        axiosClient.get('/subcategories/groupedByCats/')
            .then(response => {
                const formattedOptions = response.data.map(category => ({
                    label: category.category_name,
                    options: category.subcategories.map(sub => ({
                        value: sub.id,
                        label: sub.name
                    }))
                }));
                setSubcategoryOptions(formattedOptions);
            })
            .catch(error => {
                // console.error("Error fetching subcategories:", error)
            }
            );
        axiosClient.get('categories/')
            .then(response => {
                const formattedOptions = response.data.results.map(category => ({
                    value: category.id,
                    label: category.name
                }));
                setCategoryOptions(formattedOptions);
            })
            .catch(error => {
                // Handle error
            });
    }, []);
    useEffect(() => {
        setLoadingData(true)

        axiosClient.get(`/series/?page_size=${pageSize}&page=${currentPage + 1}&search_term=${searchTerm}&etat=${selectedEtat}&is_featured=${selectedFeature}&subcategory=${selectedSubcategory ? selectedSubcategory?.value : ''}&category=${selectedCategory ? selectedCategory?.value : ''}`)
            .then((response) => {

                let filteredData = response.data.results;
                setPaginationData(response.data);

                if (filteredData.length === 0) {
                    setCheckLengthData(true)
                }
                setSeries(filteredData);

                setLoadingData(false)
            })
            .catch((error) => {
                // console.error(error);
                setLoadingData(false)
            });
    }, [selectedEtat, pageSize, currentPage, searchTerm, selectedSubcategory, selectedCategory, selectedFeature]);

    // if (loadingData) {
    //     return (
    //         <Center h={'50vh'} mt={10}>
    //             <Spinner size="xl" />
    //         </Center>
    //     );
    // }

    if (error) {
        return (
            <Center mt={10}>
                <Text color="red.500">{error}</Text>
            </Center>
        );
    }
    const handleDelete = (id) => {
        if (!id) return;
        axiosClient.delete(`/series/delete/${id}/`)
            .then((response) => {
                setSeries((prevData) => prevData.filter((row) => row.id !== id));

                toast({
                    description: t("La serie est supprimé avec succès"),
                    status: 'success',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                })
            })
            .catch((error) => {
            });
        onCloseAlert()
    }
    const handleEtatClick = (id, etat) => {
        const formData = new FormData();
        formData.append("etat", !etat);

        axiosClient.put(`/series/update/${id}/`, formData)
            .then((response) => {
                const updatedRow = response.data;
                // Update the row object with the new etat value
                setSeries(rows => rows.map(row => {
                    if (row.id === id) {
                        return {
                            ...row,
                            etat: !etat,
                            // date_modification: updatedRow.date_modification.format('YYYY-MM-DD HH:mm:ss'),
                            // edited_by: updatedRow.edited_by || (user.first_name + ' ' + user.last_name),
                        };
                    }
                    return row;
                }));
            })
            .catch((error) => {
                // console.error(error)
            });
        if (!etat) {
            toast({
                description: t("La série est activé"),
                variant: 'left-accent',
                status: 'success',
                duration: 2000,
                isClosable: true,
                position: 'bottom-right'
            })
        }
        else {
            toast({
                description: t("La série est désactivé"),
                status: 'success',
                variant: 'left-accent',
                duration: 2000,
                isClosable: true,
                position: 'bottom-right'
            })
        }
    }
    const handleChangeFeatured = async (id, isChecked) => {
        try {
            const formData = new FormData();
            formData.append("is_featured", isChecked);
            const response = await axiosClient.put(`/series/update/${id}/`, formData);

            // Update local state
            setSeries(prev =>
                prev.map(serie =>
                    serie.id === id ? { ...serie, is_featured: isChecked } : serie
                )
            );

            toast({
                description: isChecked
                    ? "La série est affichée avec succès sur la bannière"
                    : "La série a été retirée de la bannière",
                status: 'success',
                duration: 3000,
                isClosable: true,
                position: 'bottom-right',
                variant: "left-accent"
            });

        } catch (err) {
            const errorMessage = err?.response?.data?.error || "Erreur lors de la mise à jour.";
            toast({
                description: errorMessage,
                status: 'error',
                duration: 3000,
                isClosable: true,
                position: 'bottom-right',
                variant: "left-accent"
            });
        }
    };

    const handleAddToHighlight = async () => {
        try {

            const response = await axiosClient.post('/highlighted-content/create/', {
                content: selectedContentId,
                text: highlightText,
                tag: highlightTag,
                order: 0
            });

            // Update local state if needed
            setSeries(prevSeries => prevSeries.map(serie =>
                serie.id === selectedContentId
                    ? { ...serie, is_highlighted: true, highlight_id: response.data.id }
                    : serie
            ));

            toast({
                description: "Ajouté au contenu mis en avant",
                status: "success",
                duration: 3000,
                isClosable: true,
                variant: "left-accent",
                position: "bottom-right"
            });

            setIsHighlightModalOpen(false);
        } catch (error) {
            const errorMessage = error?.response?.data?.detail;

            toast({
                description: errorMessage || "Impossible d'ajouter le contenu",
                status: "error",
                duration: 3000,
                isClosable: true,
                duration: errorMessage ? null : 3000,
                variant: "left-accent",
                position: "bottom-right"
            });
            setIsHighlightModalOpen(false);
        }
    };

    const handleAddToNewContent = async () => {
        try {
            const response = await axiosClient.post('/new-content/create/', {
                content: selectedContentId,
                order: 0
            });

            // Update local state if needed
            setSeries(prevSeries => prevSeries.map(serie =>
                serie.id === selectedContentId
                    ? { ...serie, is_new: true, new_content_id: response.data.id }
                    : serie
            ));

            toast({
                description: "Ajouté aux nouveautés",
                status: "success",
                duration: 3000,
                isClosable: true,
                variant: "left-accent",
                position: "bottom-right"
            });

            setIsNewContentModalOpen(false);
        } catch (error) {
            const errorMessage = error?.response?.data?.detail;

            toast({
                description: errorMessage || "Impossible d'ajouter le contenu",
                status: "error",
                duration: 3000,
                isClosable: true,
                duration: errorMessage ? null : 3000,
                variant: "left-accent",
                position: "bottom-right"
            });
            setIsNewContentModalOpen(false);
        }
    };

    const handleDeleteHighlight = (id) => {
        if (!id) return;
        axiosClient.delete(`/highlighted-content/delete/${id}/`)
            .then((response) => {
                setSeries(prevSeries => prevSeries.map(serie =>
                    serie.highlight_id === id
                        ? { ...serie, is_highlighted: false, highlight_id: null }
                        : serie
                ));

                toast({
                    description: t("Le contenu est supprimé de la surbrillance avec succès"),
                    status: 'success',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                })
            })
            .catch((error) => {
                // console.error(error);
            });
        onCloseAlert()
    }
    const handleDeleteNewContent = (id) => {
        if (!id) return;
        axiosClient.delete(`/new-content/delete/${id}/`)
            .then((response) => {
                setSeries(prevSeries => prevSeries.map(serie =>
                    serie.new_content_id === id
                        ? { ...serie, is_new: false, new_content_id: null }
                        : serie
                ));

                toast({
                    description: t("Le contenu est supprimé des nouveautés avec succès"),
                    status: 'success',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                })
            })
            .catch((error) => {
                // console.error(error);
            });
        onCloseAlert()
    }

    return (
        <Box p={5}>
            <Flex>
                <Box w="100%" display={"flex"} justifyContent="space-between" flexDirection={{ base: 'column', md: "row" }} mt={2} mb={{ base: 0, md: 5 }}>
                    <Text fontFamily='Plus Jakarta Display' as="cite" fontSize={{ base: "18px", md: "20px", lg: "25px" }} color="gray"><span onClick={() => navigate('/')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} >{t("Accueil")}</span>  / <span  >{t("Liste des séries")} </span></Text>
                    <Button onClick={() => navigate('/ajouter-serie')} leftIcon={<PiPlusBold />} color={"white"} bgGradient='linear(to-r, #eb6921, #fa8d51)' _hover={{ bgGradient: 'linear(to-r, #eb6921,#eb6921)' }} variant='solid'>
                        {t("Ajouter une série")}
                    </Button>
                </Box>

            </Flex>
            <Flex flexDirection={{ base: "column", lg: "row" }} gap={5} py={5} justify={"space-between"}>
                <Flex direction={{ base: 'column', md: "row" }} gap={2} w={{ base: '100%', lg: "60%" }}>
                    <Flex w={{ base: '100%', md: '50%', lg: "35%" }}>
                        <MySelect

                            options={categoryOptions}
                            onChange={setSelectedCategory}
                            placeholder="Catégorie"
                            isClearable
                            styles={{
                                container: (base) => ({
                                    ...base,

                                    zIndex: 99,
                                    width: '100%', // Make select take full width of parent (40%)
                                }),
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    border: '1px solid #CBD5E0',
                                    backgroundColor: 'transparent',
                                }),
                                menu: (provided) => ({
                                    ...provided,
                                    textAlign: 'left',
                                    backgroundColor: colorbg,
                                    cursor: "pointer"
                                }),

                                option: (provided, state) => ({
                                    ...provided,
                                    color: txtcolor,
                                    backgroundColor: state.isSelected ? colorbg : 'inherit',
                                    '&:hover': {
                                        backgroundColor: colorbghover,
                                    },
                                    cursor: "pointer"
                                }),
                                singleValue: (provided) => ({
                                    ...provided,
                                    color: txtcolor
                                }),



                            }}
                        />
                    </Flex>
                    <Select
                        style={{ border: '1px solid #CBD5E0' }}
                        borderRadius="5" fontSize={{ base: 13, lg: 16 }} w={{ base: '100%', md: '50%', lg: "35%" }} value={selectedFeature} onChange={(e) => setSelectedFeature(e.target.value === '' ? null : e.target.value === 'true')}>
                        <option value="">{t("Tout")}</option>
                        <option value="true">{t("Afficher sur la bannière")}</option>
                        <option value="false">{t("Non Afficher sur la bannière")}</option>
                    </Select>
                    <Select
                        style={{ border: '1px solid #CBD5E0' }}
                        borderRadius="5" fontSize={{ base: 13, lg: 16 }} w={{ base: '100%', md: '50%', lg: "30%" }} mb={4} value={selectedEtat} onChange={(e) => setSelectedEtat(e.target.value === '' ? null : e.target.value === 'true')}>
                        <option value="">{t("Tout")}</option>
                        <option value="true">{t("Activé")}</option>
                        <option value="false">{t("Désactivé")}</option>
                    </Select>
                </Flex>

                <InputGroup mb={3} size="md" w={{ base: '100%', lg: "40%" }}>
                    <InputLeftElement
                        pointerEvents='none'
                        children={<SearchIcon color='gray.300' />}
                    />
                    <Input
                        style={{ border: '1px solid #CBD5E0' }}

                        borderRadius="5"
                        placeholder={t("Recherche...")}
                        value={searchTerm}
                        onChange={(e) => {
                            setCurrentPage(0)
                            setSearchTerm(e.target.value)
                        }}

                        sx={{
                            marginLeft: 'auto',
                        }}
                    />  </InputGroup>

            </Flex>

            <SimpleGrid columns={!loadingData ? { base: 1, md: 2, lg: 3 } : { base: 1 }} spacing={5}>
                {!loadingData
                    ? series.length > 0
                        ? series.map((serie) => (
                            <Card
                                // cursor={'pointer'} 
                                // onClick={() =>
                                //     navigate(`/detail-serie`, {
                                //         state: {
                                //             serieId: serie.id,
                                //         },
                                //     })
                                // } 
                                key={serie.id} borderRadius="md"
                                // overflow="hidden" 
                                boxShadow="md">
                                <Box position="relative">
                                    <Menu >
                                        <MenuButton position="absolute" top="5px" right="5px" zIndex="999" as={IconButton} icon={<BsThreeDotsVertical />} variant="ghost" color="orange" />
                                        <MenuList zIndex="9999">
                                            <MenuItem _hover={{ background: "none" }} onClick={() => navigate(`/detail-serie`, { state: { serieId: serie?.id } })}>
                                                Détails de série
                                            </MenuItem>
                                            <MenuItem _hover={{ background: "none" }} onClick={() =>
                                                navigate(`/modifier-serie`, {
                                                    state: {
                                                        serieId: serie?.id,
                                                    },
                                                })
                                            }>Modifier la série</MenuItem>
                                            <MenuItem _hover={{ background: "none" }} onClick={() =>
                                                navigate(`/historique_serie`, {
                                                    state: {
                                                        serieId: serie?.id,
                                                    },
                                                })
                                            }>Historique de série</MenuItem>

                                            <MenuItem closeOnSelect={false}>
                                                <Checkbox
                                                    isChecked={serie?.is_featured}
                                                    onChange={async (e) => {
                                                        const isChecked = e.target.checked;

                                                        try {
                                                            await handleChangeFeatured(serie?.id, isChecked);
                                                        } catch (error) {
                                                            toast({
                                                                description: error?.message || "Une erreur est survenue",
                                                                status: "error",
                                                                duration: 3000,
                                                                isClosable: true,
                                                                position: "bottom-right",
                                                                variant: "left-accent"
                                                            });
                                                        }
                                                    }}
                                                >
                                                    Mettre en bannier
                                                </Checkbox>
                                            </MenuItem>

                                            <MenuItem _hover={{ background: "none" }}>

                                                <Flex w={"100%"} justifyContent="space-between">


                                                    <Badge
                                                        size="sm"
                                                        rounded={'lg'}
                                                        colorScheme={!serie.etat ? 'red' : 'green'}
                                                    >
                                                        {serie.etat ? t("Activé") : t("Désactivé")}

                                                    </Badge>
                                                    <Stack direction='row' mr="3px">
                                                        {(user.role === "SUPERADMIN" || user.role === "ADMIN") &&
                                                            <Switch
                                                                colorScheme='green'
                                                                isChecked={serie.etat}
                                                                onChange={() => handleEtatClick(serie.id, serie.etat)}
                                                            />
                                                        }
                                                    </Stack>
                                                </Flex>
                                            </MenuItem>
                                            <MenuItem onClick={() => { handleOpenRatingsModal(serie.id) }}>
                                                Afficher les avis
                                            </MenuItem>
                                            {serie.is_highlighted ?

                                                <MenuItem onClick={() => handleDeleteHighlight(serie.highlight_id)}>
                                                    Supprimer de highlight
                                                </MenuItem>
                                                :
                                                <MenuItem onClick={() => openHighlightModal(serie.id)}>
                                                    Ajouter en highlight
                                                </MenuItem>
                                            }
                                            {serie.is_new ?

                                                <MenuItem onClick={() => handleDeleteNewContent(serie.new_content_id)}>
                                                    Retirer des nouveautés
                                                </MenuItem>
                                                :
                                                <MenuItem onClick={() => openNewContentModal(serie.id)}>
                                                    Ajouter aux nouveautés
                                                </MenuItem>
                                            }
                                            {(user.role === "SUPERADMIN") &&
                                                <>
                                                    <MenuDivider />
                                                    <MenuItem onClick={() => {
                                                        onOpenAlert(serie.id);
                                                    }} _hover={{ background: "none" }} color="red.500" >Supprimer la série</MenuItem>

                                                </>
                                            }
                                        </MenuList>

                                    </Menu>
                                    <Image borderRadius="md" height="200px" width="100%" src={serie.image} alt={serie.title} />
                                    <CardBody
                                        borderRadius="md"
                                        position="absolute"
                                        top="0"
                                        left="0"
                                        right="0"
                                        bottom="0"
                                        p={4}
                                        bg="rgba(0, 0, 0, 0.5)"
                                        color="white"
                                        backdropFilter={"auto"}
                                        backdropBlur={"2px"}
                                    >
                                        <Flex w={"100%"} h={"100%"} align={"center"} justify={"center"} direction={"column"}>

                                            <Text fontSize="xl" fontWeight="bold">{serie.title}</Text>
                                            <Text mt={2} color="gray.300" fontSize="sm">
                                                {serie.description.length > 80 ? `${serie.description.slice(0, 80)}...` : serie.description}
                                            </Text>
                                            <Flex mt={4} justifyContent="space-between" alignItems="center">
                                                <Text fontSize="sm" color="gray.200">
                                                    Année de sortie : {serie.releaseDate ? serie.releaseDate.split("-")[0] : "N/A"}
                                                </Text>
                                            </Flex>
                                        </Flex>
                                    </CardBody>
                                </Box>
                            </Card>

                        ))
                        : <Text >{t("Aucune série correspondante n'a été trouvée.")}</Text>

                    :
                    <Flex justify='center'>
                        <Spinner size="xl" />
                    </Flex>
                }
                {/* {(((searchTerm || selectedEtat !== null || selectedSubcategory !== null) && paginationData?.length === 0) || (checkLengthData)) && (
                                    <Text >{t("Aucune ligne correspondante n'a été trouvée.")}</Text>
                                )} */}
            </SimpleGrid>
            <Flex flexDirection={{ base: 'column', lg: "row" }} justify="space-between" align="center" w="100%">
                <Box flex="1">
                    <MyPagination
                        paginationData={paginationData}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        PAGE_SIZE={pageSize}
                    />
                </Box>

                <Select w="70px" value={pageSize} onChange={handlePageSizeChange}>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="40">40</option>
                    <option value="50">50</option>
                    {/* Add more options as needed */}
                </Select>
            </Flex>
            <AlertDialog
                isOpen={isAlertOpen}
                leastDestructiveRef={cancelRef}
                onClose={onCloseAlert}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t("Supprimer le film")}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            {t("êtes-vous sûr ? Vous ne pourrez pas annuler cette action ultérieurement.")}
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onCloseAlert}>
                                {t("Annuler")}
                            </Button>
                            <Button onClick={() => handleDelete(deleteId)} colorScheme='red' ml={3}>
                                {t("Supprimer")}
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
            <Modal isOpen={isHighlightModalOpen} onClose={() => setIsHighlightModalOpen(false)}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Ajouter en highlight</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text mb={2}>Souhaitez-vous ajouter un texte pour ce contenu en tant que mise en avant ?</Text>
                        <Input
                            mb={2}
                            placeholder="Tag (ex: 🔥 Exclusif, 🕑 Disponible...)"
                            value={highlightTag}
                            onChange={(e) => setHighlightTag(e.target.value)}
                        />
                        <Textarea
                            placeholder="Texte de la mise en avant (facultatif)"
                            value={highlightText}
                            onChange={(e) => setHighlightText(e.target.value)}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="blue" mr={3} onClick={handleAddToHighlight}>
                            Ajouter
                        </Button>
                        <Button colorScheme="gray" onClick={() => setIsHighlightModalOpen(false)}>Annuler</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            <Modal isOpen={isNewContentModalOpen} onClose={() => setIsNewContentModalOpen(false)}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Ajouter aux nouveautés</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text mb={2}>Confirmez-vous l’ajout de ce contenu aux nouveautés ?</Text>

                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="blue" mr={3} onClick={handleAddToNewContent}>
                            Ajouter
                        </Button>
                        <Button colorScheme="gray" onClick={() => setIsNewContentModalOpen(false)}>Annuler</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            <RatingsModal
                isOpen={isOpen}
                onClose={onClose}
                contentId={contentId}
            />
        </Box>
    );
};

export default GestSeries;
